import { JourneyDataModel } from '../../../../services/redux/features/journeyData.slice';
import { DirectorPersonFormModel_OB_OL } from './formModel';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const requestMapper = (values: DirectorPersonFormModel_OB_OL): Partial<JourneyDataModel> => {
  return {};
};
